import React from 'react';
import { Trans } from 'react-i18next';
class SecretCounter extends React.Component {
  state = {
    open: false,
    countersecr: 'countersecr',
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <div className="counter" value="0" id="qty">
        <div className="countersecreet">
          <span id={this.state.countersecr}>0</span>/8
        </div>
        <span
          style={{
            position: `absolute`,
            zIndex: `8`,
            right: `63px`,
            top: `14px`,
            color: `#fff`,
            fontSize: `14px`,
            textTransform: `uppercase`,
            fontFamily: `'Roboto', sans-serif`,
            textShadow: `1px 1px #000`,
          }}
        >
          <Trans i18nKey="menu.secret">Secret(s)</Trans>
        </span>
      </div>
    );
  }
}

export default SecretCounter;



// WEBPACK FOOTER //
// ./src/components/App/secretCounter.js